import { CartState } from '../state';
import { setToLocalStorage } from '../../../../../utils';
import { LocalStorageKeys } from '../../../../../enums/local-storage-keys';

export const clearCartReducer = (state: CartState) => {
  state.cart = null;
  state.countItems = 0;
  state.countProductVariants = 0;
  state.countBundles = 0;
  state.countTrials = 0;
  state.includesTrial = false;
  state.includesBLG = false;
  state.includesDrops = false;
  state.includesDoctor = false;
  state.includesPrescription = false;

  setToLocalStorage(LocalStorageKeys.CART_STATE, state);
};
